/** Shared Statsig experiment runner — load after experiment.js; per-test files call registerStatsigExperiment. */
(function () {
  'use strict';

  var queue = window.__PXU_STATSIG_EXPERIMENTS__ || (window.__PXU_STATSIG_EXPERIMENTS__ = []);
  var runScheduled = false;

  function getExperimentGroupName(experiment) {
    if (!experiment) {
      return '';
    }
    if (typeof experiment.groupName === 'string' && experiment.groupName) {
      return experiment.groupName;
    }
    if (typeof experiment.getGroupName === 'function') {
      return experiment.getGroupName() || '';
    }
    return '';
  }

  /**
   * Local QA bypass (no Statsig console override):
   * - URL: ?pxu_exp_force=1  persist force for this experiment (localStorage)
   * - URL: ?pxu_exp_force=0  clear persisted force
   * - omit pxu_exp_force     leave persisted force unchanged
   * - URL: ?pxu_exp_Mega_menu=1  or  ?pxu_exp=Mega_menu  (this page only)
   * - localStorage: pxu_exp_force = Mega_menu
   *
   * Forced visits skip getExperiment() so Statsig does not log an experiment exposure.
   */
  function syncForceFromQuery(experimentId) {
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has('pxu_exp_force')) {
        return;
      }
      var force = String(params.get('pxu_exp_force') || '').toLowerCase();
      if (force === '1' || force === 'true') {
        window.localStorage.setItem('pxu_exp_force', experimentId);
      } else if (force === '0' || force === 'false') {
        window.localStorage.removeItem('pxu_exp_force');
      }
    } catch (e) {
      /* ignore */
    }
  }

  function isLocallyForcedTreatment(experimentId) {
    if (!experimentId) {
      return false;
    }
    try {
      syncForceFromQuery(experimentId);
      if (window.localStorage.getItem('pxu_exp_force') === experimentId) {
        return true;
      }
      var params = new URLSearchParams(window.location.search);
      if (params.get('pxu_exp') === experimentId) {
        return true;
      }
      var flag = params.get('pxu_exp_' + experimentId);
      if (flag === '1' || flag === 'true' || /^test$/i.test(flag || '')) {
        return true;
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  }

  function defaultIsTreatment(groupName, experiment) {
    var compactPadding =
      typeof experiment.get === 'function' ? experiment.get('compact_link_padding', false) : false;
    if (compactPadding) {
      return true;
    }
    if (!groupName || typeof groupName !== 'string') {
      return false;
    }
    return !/^control$/i.test(groupName.trim());
  }

  function runOne(definition, statsig) {
    if (!statsig || typeof statsig.getExperiment !== 'function') {
      return;
    }
    if (!definition || !definition.id || typeof definition.apply !== 'function') {
      return;
    }

    /* URL / localStorage force: run apply only — do not call getExperiment (no exposure). */
    if (isLocallyForcedTreatment(definition.id)) {
      definition.apply('', null);
      return;
    }

    var experiment = statsig.getExperiment(definition.id);
    if (!experiment) {
      return;
    }

    var groupName = getExperimentGroupName(experiment);
    var isTreatment =
      typeof definition.isTreatment === 'function'
        ? definition.isTreatment(groupName, experiment)
        : defaultIsTreatment(groupName, experiment);

    if (isTreatment) {
      definition.apply(groupName, experiment);
    }
  }

  function whenStatsigReady(fn) {
    var statsig = window.PXUTheme && window.PXUTheme.statsig;
    if (statsig) {
      var ready = statsig.ready;
      if (ready && typeof ready.then === 'function') {
        ready.then(function () {
          fn(statsig);
        });
        return;
      }
      fn(statsig);
      return;
    }
    document.addEventListener(
      'statsig:ready',
      function () {
        fn(window.PXUTheme && window.PXUTheme.statsig);
      },
      { once: true }
    );
  }

  function runAllRegistered() {
    whenStatsigReady(function (statsig) {
      queue.forEach(function (definition) {
        runOne(definition, statsig);
      });
    });
  }

  window.registerStatsigExperiment = function (definition) {
    queue.push(definition);
    if (!runScheduled) {
      runScheduled = true;
      runAllRegistered();
    }
  };
})();
